// Google Form Submission Service for Siwon Galaxy Quiz
// Handles both Lead Capture (before quiz) and Full Results (after quiz)
// Form ID: 1FAIpQLSccIQa-TzK8pcBuRMOU3HUACJTaaCkx4LmVyJi3FXuY-_eUyw

const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSccIQa-TzK8pcBuRMOU3HUACJTaaCkx4LmVyJi3FXuY-_eUyw/formResponse";

// Form field entry IDs
const FORM_FIELDS = {
  name: "entry.409244431",
  email: "entry.1902449949",
  phone: "entry.1897757460",
  annamaya: "entry.1563795417",
  pranamaya: "entry.116605288",
  manomaya: "entry.1898248378",
  vijnanamaya: "entry.371895946",
  anandamaya: "entry.97049801",
  overall: "entry.1328910477",
  quizType: "entry.1230605686",
  resultsSummary: "entry.214476580"
};

/**
 * Submit lead capture data BEFORE quiz starts
 * This captures users who may not complete the quiz
 * @param {Object} userData - User information (name, email, phone)
 * @param {string} quizType - Type of quiz ("Relationship" or "Life")
 * @returns {Promise<boolean>} - Success status
 */
export const submitLeadCapture = async (userData, quizType) => {
  try {
    const formData = new URLSearchParams();
    
    // User data
    formData.append(FORM_FIELDS.name, userData.name || "");
    formData.append(FORM_FIELDS.email, userData.email || "");
    formData.append(FORM_FIELDS.phone, userData.phone || "");
    
    // Use 0 for scores (not empty) - quiz not started yet
    formData.append(FORM_FIELDS.annamaya, "0");
    formData.append(FORM_FIELDS.pranamaya, "0");
    formData.append(FORM_FIELDS.manomaya, "0");
    formData.append(FORM_FIELDS.vijnanamaya, "0");
    formData.append(FORM_FIELDS.anandamaya, "0");
    formData.append(FORM_FIELDS.overall, "0");
    
    // Quiz type
    formData.append(FORM_FIELDS.quizType, quizType);
    
    // Status indicator - STARTED
    formData.append(FORM_FIELDS.resultsSummary, `STARTED - Quiz Initiated at ${new Date().toLocaleString('en-IN')}`);
    
    // Submit to Google Form
    await fetch(GOOGLE_FORM_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    });
    
    console.log("Lead capture submitted to Google Form successfully");
    return true;
  } catch (error) {
    console.error("Error submitting lead capture:", error);
    return false;
  }
};

/**
 * Submit complete quiz results after quiz completion
 * @param {Object} userData - User information (name, email, phone)
 * @param {Object} results - Quiz results (annamaya, pranamaya, manomaya, vijnanamaya, anandamaya, overall)
 * @param {string} quizType - Type of quiz ("Relationship" or "Life")
 * @returns {Promise<boolean>} - Success status
 */
export const submitQuizResults = async (userData, results, quizType) => {
  try {
    const formData = new URLSearchParams();
    
    // User data
    formData.append(FORM_FIELDS.name, userData.name || "");
    formData.append(FORM_FIELDS.email, userData.email || "");
    formData.append(FORM_FIELDS.phone, userData.phone || "");
    
    // Quiz scores
    formData.append(FORM_FIELDS.annamaya, String(results.annamaya || 0));
    formData.append(FORM_FIELDS.pranamaya, String(results.pranamaya || 0));
    formData.append(FORM_FIELDS.manomaya, String(results.manomaya || 0));
    formData.append(FORM_FIELDS.vijnanamaya, String(results.vijnanamaya || 0));
    formData.append(FORM_FIELDS.anandamaya, String(results.anandamaya || 0));
    formData.append(FORM_FIELDS.overall, String(results.overall || 0));
    
    // Quiz type
    formData.append(FORM_FIELDS.quizType, quizType);
    
    // Full results summary with completion status
    const summary = `COMPLETED - Overall: ${results.overall}% | Physical: ${results.annamaya}% | Energy: ${results.pranamaya}% | Mind: ${results.manomaya}% | Wisdom: ${results.vijnanamaya}% | Bliss: ${results.anandamaya}%`;
    formData.append(FORM_FIELDS.resultsSummary, summary);
    
    // Submit to Google Form
    await fetch(GOOGLE_FORM_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    });
    
    console.log("Quiz results submitted to Google Form successfully");
    return true;
  } catch (error) {
    console.error("Error submitting quiz results:", error);
    return false;
  }
};

export default submitQuizResults;
